import React, { useEffect, useState } from 'react';
import Icon from '../../common/Icon/Icon';
import {
  computeElapsedSinceContactDate,
  formatElapsedSinceContact,
} from '../../../utils';
import styles from '../StudentConsolidatedHistoryPanel/StudentConsolidatedHistoryPanel.module.css';

interface StudentMariContactChronometerProps {
  contactedAt: string | null;
}

const StudentMariContactChronometer: React.FC<StudentMariContactChronometerProps> = ({
  contactedAt,
}) => {
  const [nowMs, setNowMs] = useState(() => Date.now());

  useEffect(() => {
    if (!contactedAt) {
      return;
    }

    let timeoutId = 0;
    let cancelled = false;

    const scheduleNextTick = () => {
      if (cancelled) {
        return;
      }

      setNowMs(Date.now());
      const msUntilNextSecond = 1_000 - (Date.now() % 1_000);
      timeoutId = window.setTimeout(scheduleNextTick, msUntilNextSecond);
    };

    scheduleNextTick();

    return () => {
      cancelled = true;
      window.clearTimeout(timeoutId);
    };
  }, [contactedAt]);

  const label = contactedAt
    ? formatElapsedSinceContact(computeElapsedSinceContactDate(contactedAt, nowMs))
    : 'Sem contato registrado';

  return (
    <div className={styles['mari-contact-timer']} role="timer" aria-atomic="true">
      <Icon name="schedule" size={18} color="var(--color-text-muted)" />
      <span className={styles['mari-contact-timer-value']}>{label}</span>
    </div>
  );
};

export default StudentMariContactChronometer;
